import { useState, useEffect } from 'react';
import { useApp } from 'contexts/app';
import PricingService from 'services/pricing';

const service = new PricingService();

const useComponent = () => {
    const { showLoading, showNotify } = useApp();
    const [enabled, setEnabled] = useState(false);

    useEffect(() => {
        load();
    }, []);

    const load = async () => {
        const setting = await service.getSetting();
        setEnabled(!!setting?.enabled);
    };

    const onSave = async () => {
        showLoading(true);
        await service.saveSetting({ enabled });
        showLoading(false);
        showNotify("Đã lưu cấu hình");
    };

    return { enabled, setEnabled, onSave };
};

export default useComponent;
